import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RouterModule, Routes } from '@angular/router';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
//Translate service
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
// AoT requires an exported function for factories
export function httpLoaderFactory(httpClient: HttpClient) {
  //prende il path di default assets/i18n/lang-code.json
  //return new TranslateHttpLoader(httpClient);

  return new TranslateHttpLoader(httpClient,
  environment.i18nPath);
}

//Material Components
import { FlexLayoutModule } from '@angular/flex-layout';
import {
  MatToolbarModule,
  MatMenuModule,
  MatIconModule,
  MatButtonModule,
  MatTableModule,
  MatDividerModule,
  MatProgressSpinnerModule,
  MatInputModule,
  MatCardModule,
  MatSlideToggleModule,
  MatSelectModule,
  MatOptionModule,
  MatSidenavModule,
  MatTreeModule,
  MatProgressBarModule,
  MatDialogModule,
  MatCheckboxModule,
  MatListModule,
  MatSnackBarModule,
  MatTooltipModule
} from '@angular/material';

//Repository components
import { FolderTreeComponent } from './components/folder-tree/folder-tree.component';
import { CreateFolderDialogComponent } from './components/create-folder-dialog/create-folder-dialog.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { RenameFolderDialogComponent } from './components/rename-folder-dialog/rename-folder-dialog.component';
import { MoveFolderDialogComponent } from './components/move-folder-dialog/move-folder-dialog.component';
import { FolderMoveTreeComponent } from './components/folder-move-tree/folder-move-tree.component';
import { FileManagerComponent } from './components/file-manager/file-manager.component';
import { RenameFileDialogComponent } from './components/rename-file-dialog/rename-file-dialog.component';
import { UploadFileDialogComponent } from './components/upload-files-dialog/upload-files-dialog.component';
import { MoveFilesDialogComponent } from './components/move-files-dialog/move-files-dialog.component';
//Repository Directives
import { NgVarDirective } from './directives/ngVar/ng-var.directive';
import { DragDirective } from './directives/Drag/drag.directive';
//Repository Pages
import { LoginComponent } from './pages/login/login.component';
import { HomeComponent } from './pages/home/home.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
//Repository services
import { AuthGuardService } from './services/AuthGuard/auth-guard.service';
import { environment } from 'src/environments/environment';

const ROUTES: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: '404',
    component: NotFoundComponent
  },
  {
    path: '**',
    redirectTo: '/404'
  }
];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    NotFoundComponent,
    FolderTreeComponent,
    CreateFolderDialogComponent,
    ConfirmDialogComponent,
    RenameFolderDialogComponent,
    MoveFolderDialogComponent,
    FolderMoveTreeComponent,
    NgVarDirective,
    FileManagerComponent,
    RenameFileDialogComponent,
    UploadFileDialogComponent,
    DragDirective,
    MoveFilesDialogComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule.forRoot(ROUTES),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    MatInputModule,
    MatCardModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatDividerModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatOptionModule,
    MatProgressSpinnerModule,
    HttpClientModule,
    MatSidenavModule,
    FlexLayoutModule,
    MatTreeModule,
    MatProgressBarModule,
    MatDialogModule,
    MatCheckboxModule,
    MatListModule,
    MatSnackBarModule,
    MatTooltipModule
  ],
  providers: [],
  bootstrap: [AppComponent],
  entryComponents: [
    CreateFolderDialogComponent,
    RenameFolderDialogComponent,
    RenameFileDialogComponent,
    MoveFolderDialogComponent,
    MoveFilesDialogComponent,
    ConfirmDialogComponent,
    UploadFileDialogComponent
  ]
})
export class AppModule { }
